"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EventEmitter = require("wolfy87-eventemitter");
const LogManager_1 = require("../Log/LogManager");
const TypeScriptUtils_1 = require("../Common/TypeScriptUtils");
const CommonBaseError_1 = require("../Common/CommonBaseError");
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
const DomainCommandHandler_1 = require("../Engine/Command/DomainCommandHandler");
const DomainEventHandler_1 = require("../Engine/Event/DomainEventHandler");
const FudaoEvent_1 = require("./FudaoEvent");
const FudaoUser_1 = require("./FudaoUser");
const FudaoCommand_1 = require("./FudaoCommand");
const FudaoDefinition_1 = require("./FudaoDefinition");
const Fudao_1 = require("./Fudao");
const FudaoDto_1 = require("./Protocol/FudaoDto");
class FudaoClientApplicationServiceBase {
    constructor(fps, ccas, iff, ifr, cmdHub, evtHub) {
        this._logger = LogManager_1.logManager.GetLogger("FudaoClientApplicationServiceBase");
        this._curFudaoUser = FudaoUser_1.FudaoUser.INVALID_FUDAO_USER;
        this.errorOccurred = new EventEmitter();
        this._fudaoPassportService = fps;
        this._chatAppService = ccas;
        this._fudaoFac = iff;
        this._fudaoRepo = ifr;
        this._cmdHub = cmdHub;
        this._evtHub = evtHub;
        this._commandHandler = new DomainCommandHandler_1.DomainCommandHandler(FudaoCommand_1.FudaoCommand.Category, this._logger, cmdHub);
        this._commandHandler.registerAsyncCommandHandler(FudaoCommand_1.FudaoCommand.TeacherInviteStartFudao, async (rtcCmd) => this.onInviteFudaoAsync(rtcCmd));
        this._eventHandler = new DomainEventHandler_1.DomainEventHandler(FudaoEvent_1.FudaoEvent.Category, this._logger);
    }
    async initAsync(initFudaoUser) {
        this._curFudaoUser = await this._fudaoPassportService.QueryFudaoUser(initFudaoUser.Id);
        this._cmdHub.errorOccurred.addListener(FudaoCommand_1.FudaoCommand.Category, (error) => this.reportError(error));
        this._evtHub.errorOccurred.addListener(FudaoEvent_1.FudaoEvent.Category, (error) => this.reportError(error));
        this._cmdHub.registerCommandHandler(FudaoCommand_1.FudaoCommand.Category, this);
        this._evtHub.registerEventHandler(FudaoEvent_1.FudaoEvent.Category, this);
    }
    async terminateAsync() {
        this._evtHub.unRegisterEventHandler(FudaoEvent_1.FudaoEvent.Category);
        this._cmdHub.unRegisterCommandHandler(FudaoCommand_1.FudaoCommand.Category);
        this._evtHub.errorOccurred.removeListener(FudaoEvent_1.FudaoEvent.Category, this.reportError);
        this._cmdHub.errorOccurred.removeListener(FudaoCommand_1.FudaoCommand.Category, this.reportError);
        await this.clearAllLocalDataAsync();
        this.errorOccurred.removeAllListeners();
        this._curFudaoUser = FudaoUser_1.FudaoUser.INVALID_FUDAO_USER;
    }
    handleCommand(cmd) {
        this._commandHandler.handleCommand(cmd);
    }
    async handleCommandAsync(cmd) {
        if (!TypeScriptUtils_1.isNullOrEmpty(cmd.targetId)) {
            const fudaoId = cmd.targetId;
            const fudao = await this._fudaoRepo.FudaoOfIdAsync(fudaoId);
            if (fudao !== Fudao_1.Fudao.INVALID_FUDAO) {
                await fudao.handleCommandAsync(cmd);
                return;
            }
        }
        await this._commandHandler.handleCommandAsync(cmd);
    }
    reportError(error) {
        try {
            const fudaoAppServiceError = (error instanceof FudaoApplicationServiceError) ? error : new FudaoApplicationServiceError(error.message, error);
            this.errorOccurred.emitEvent(exports.FudaoApplicationServiceErrorName, [fudaoAppServiceError]);
        }
        catch (e) {
            // Prevent outside error handler throwing error again.
            this._logger.error(e.message, e);
        }
    }
    handleEvent(e) {
        this.HandleFudaoFailureEvent(e);
        if (e.isLocal)
            return;
        if (!TypeScriptUtils_1.isNullOrEmpty(e.entityId)) {
            const fudao = this._fudaoRepo.FudaoOfId(e.entityId);
            if (fudao !== Fudao_1.Fudao.INVALID_FUDAO) {
                fudao.handleEvent(e);
                return;
            }
        }
        this._eventHandler.handleEvent(e);
    }
    async handleEventAsync(e) {
        this.HandleFudaoFailureEvent(e);
        if (e.isLocal)
            return;
        if (!TypeScriptUtils_1.isNullOrEmpty(e.entityId)) {
            const fudao = await this._fudaoRepo.FudaoOfIdAsync(e.entityId);
            if (fudao !== Fudao_1.Fudao.INVALID_FUDAO) {
                await fudao.handleEventAsync(e);
                return;
            }
        }
        await this._eventHandler.handleEventAsync(e);
    }
    /**
     * 處理Fudao相關的失敗Event，目前還沒有完整的Fudao每個環節錯誤的處理機制，FudaoClientApplicationService先自己收下來用共用機制顯示錯誤，有更詳細的設計再來處理
     *
     * @private
     * @param {DomainEvent} e 輔導相關失敗Event
     * @memberof FudaoClientApplicationServiceBase
     */
    HandleFudaoFailureEvent(e) {
        if (e.name === FudaoEvent_1.FudaoEvent.FudaoStartFailed) {
            this.reportError(new FudaoApplicationServiceError(e.bodyTo()));
        }
        else if (e.name === FudaoEvent_1.FudaoEvent.FudaoSessionFailed) {
            this.reportError(new FudaoApplicationServiceError(e.bodyTo()));
        }
    }
    subscribeEventHandler(eventName, onEventHandler) {
        return this._evtHub.subscribeEventHandler(FudaoEvent_1.FudaoEvent.Category, eventName, onEventHandler, (err) => this.reportError(err));
    }
    subscribeEventAsyncHandler(eventName, onEventHandler) {
        return this._evtHub.subscribeEventAsyncHandler(FudaoEvent_1.FudaoEvent.Category, eventName, onEventHandler, (err) => this.reportError(err));
    }
    get localFudaoUser() { return this._curFudaoUser; }
    /**
     * 用userId查詢參與Fudao的FudaoUser
     *
     * @param {string} userId
     * @returns {Promise<FudaoUser>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async queryFudaoUser(userId) {
        const result = await this.executeAsync(async () => {
            return await this._fudaoPassportService.QueryFudaoUser(userId);
        }, FudaoUser_1.FudaoUser.INVALID_FUDAO_USER);
        return result;
    }
    /**
     * 用輔導Id查詢輔導
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<FudaoDto>} 有查到就回傳FudaoDto，沒查到或失敗就回傳FudaoDto.INVALID_FUDAO_DTO代表無效的輔導
     * @memberof FudaoClientApplicationServiceBase
     */
    async fudaoOfIdAsync(fudaoId) {
        const result = await this.executeAsync(async () => {
            const fudao = await this._fudaoRepo.FudaoOfIdAsync(fudaoId);
            return fudao.ToFudaoDto();
        }, FudaoDto_1.FudaoDto.INVALID_FUDAO_DTO);
        return result;
    }
    /**
     * 查詢輔導的課時
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<number>} 輔導課時，以毫秒計
     * @memberof FudaoClientApplicationServiceBase
     */
    async queryFudaoTotalTimeAsync(fudaoId) {
        return await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const duration = await fudao.CalculateTotalTimeAsync();
            return duration.asMilliseconds();
        });
    }
    /**
     * 詢問輔導時間是否已經結束
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<boolean>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async isFudaoTimeUp(fudaoId) {
        return await this.executeFudaoOperation(fudaoId, (fudao) => {
            return fudao.IsTimeUp();
        });
    }
    /**
     * 老師邀請學生開始輔導
     *
     * @param {string} studentId 學生Id
     * @returns {Promise<FudaoDto>} 已送出邀請的FudaoDto
     * @memberof FudaoClientApplicationServiceBase
     */
    async inviteFudaoAsync(studentId) {
        try {
            if (this._curFudaoUser === FudaoUser_1.FudaoUser.INVALID_FUDAO_USER)
                throw new FudaoApplicationServiceError("No related fudao user");
            if (!studentId)
                throw new FudaoApplicationServiceError("studentId should not be empty.");
            //檢查是否有進行中的輔導
            //檢查是否雙方都有資料
            const teacher = this._curFudaoUser;
            if (teacher === FudaoUser_1.FudaoUser.INVALID_FUDAO_USER)
                throw new FudaoApplicationServiceError(`No teacher with ${this._curFudaoUser.Id}`);
            const student = await this._fudaoPassportService.QueryFudaoUser(studentId);
            if (student === FudaoUser_1.FudaoUser.INVALID_FUDAO_USER)
                throw new FudaoApplicationServiceError(`No student with ${studentId}`);
            //生成輔導
            const fudao = await this._fudaoFac.NewFudaoAsync(teacher, student);
            //老師發出輔導邀請
            await fudao.InviteStartAsync(teacher, student);
            //_logger.Debug(() =>
            //{
            //    var fudaoDto = FudaoDto.From(fudao);
            //    //JsonSerializerSettings settings = new JsonSerializerSettings { TypeNameHandling = TypeNameHandling.All };
            //    var json = JsonConvert.SerializeObject(fudaoDto, Formatting.Indented);
            //    return $"Serialized: \n{json}";
            //});
            //SimulateStudentResponse(FudaoCommand.TeacherInviteStartFudao, fudao, teacher);
            return fudao.ToFudaoDto();
        }
        catch (err) {
            const appServiceError = new FudaoApplicationServiceError(err.message, err);
            this.reportError(appServiceError);
            return FudaoDto_1.FudaoDto.INVALID_FUDAO_DTO;
        }
    }
    async onInviteFudaoAsync(rtcCmd) {
        switch (rtcCmd.type) {
            case RtcCommand_1.CmdType.RequestExecute:
                const fudaoDto = new FudaoDto_1.FudaoDto(rtcCmd.contentTo());
                const fudao = this._fudaoFac.CreateFudaoFrom(fudaoDto);
                await this._fudaoRepo.SaveAsync(fudao);
                await fudao.handleCommandAsync(rtcCmd);
                break;
        }
    }
    /**
     * 學生接受開始輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async acceptFudaoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //學生接受輔導邀請
            const student = this._curFudaoUser;
            //準備好與Teacher的Chat
            const chatId = await this._chatAppService.openOrCreateChatWithAsync([fudao.Teacher.Name]);
            if (TypeScriptUtils_1.isNullOrEmpty(chatId))
                throw new FudaoApplicationServiceError(`Can't open chat with ${fudao.Teacher.Name}`);
            await fudao.AcceptStartInvitationAsync(student);
        });
    }
    /**
     * 學生拒絕開始輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async rejectFudaoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //學生拒絕輔導
            const student = this._curFudaoUser;
            await fudao.RejectStartInvitationAsync(student);
        });
    }
    /**
     * 老師取消開始輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async cancelFudaoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //老師取消輔導
            const teacher = this._curFudaoUser;
            await fudao.CancelStartInvitationAsync(teacher);
        });
    }
    /**
     * 老師與學生回報學生無回應開始輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async noResponseFudaoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //開始輔導邀請無人回應
            await fudao.NoResponseStartInvitationAsync(this._curFudaoUser);
        });
    }
    /**
     * 老師開始輔導
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<boolean>} 開始輔導成功或失敗
     * @memberof FudaoClientApplicationServiceBase
     */
    async startFudaoAsync(fudaoId) {
        const result = await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            await fudao.StartAsync(teacher);
            return true;
        }, false);
        return result;
    }
    /**
     * 老師邀請學生結束輔導
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async inviteEndFudaoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //老師邀請結束輔導
            const teacher = this._curFudaoUser;
            await fudao.InviteEndAsync(teacher);
            //SimulateStudentResponse(FudaoCommand.TeacherInviteEndFudao, fudao, teacher);
        });
    }
    /**
     * 老師取消結束輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async cancelEndFudaoInvition(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //老師取消邀請結束輔導
            const teacher = this._curFudaoUser;
            await fudao.CancelEndInvitationAsync(teacher);
        });
    }
    /**
     * 學生接受結束輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async acceptEndFudaoInvition(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //學生接受老師邀請結束輔導
            const student = this._curFudaoUser;
            await fudao.AcceptEndInvitionAsync(student);
        });
    }
    /**
     * 學生拒絕結束輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async rejectEndFudaoInvition(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //學生拒絕老師邀請結束輔導
            const student = this._curFudaoUser;
            await fudao.RejectEndInvitionAsync(student);
        });
    }
    /**
     * 老師與學生回報學生無回應結束輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async noResponseEndFuadoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //延長輔導邀請無人回應
            await fudao.NoResponseEndInvitationAsync(this._curFudaoUser);
        });
    }
    /**
     * 老師結束輔導
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async endFudaoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            await fudao.EndAsync(teacher);
        });
    }
    /**
     * 老師或學生強制中斷輔導
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async interruptFudaoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //老師或學生強迫中止輔導
            await fudao.InterruptAsync(this._curFudaoUser);
        });
    }
    /**
     * 老師邀請學生延長輔導
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async inviteExtendFudaoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //老師應請延長輔導
            const teacher = this._curFudaoUser;
            await fudao.InviteExtendAsync(teacher);
            //SimulateStudentResponse(FudaoCommand.TeacherInviteExtendFudao, fudao, teacher);
        });
    }
    /**
     * 老師取消邀請延長輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async cancelExtendFudaoInvition(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            await fudao.CancelExtendInvitationAsync(teacher);
        });
    }
    /**
     * 學生接受延長輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async acceptExtendFudaoInvition(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //學生接受老師邀請延長輔導
            const student = this._curFudaoUser;
            await fudao.AcceptExtendInvitionAsync(student);
        });
    }
    /**
     * 學生拒絕延長輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async rejectExtendFudaoInvition(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            //學生拒絕老師邀請延長輔導
            const student = this._curFudaoUser;
            await fudao.RejectExtendInvitionAsync(student);
        });
    }
    /**
     * 老師與學生回報學生無回應延長輔導邀請
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async noResponseExtendFuadoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            await fudao.NoResponseExtendInvitationAsync(this._curFudaoUser);
        });
    }
    /**
     * 老師延長輔導
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async extendFudaoAsync(fudaoId) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            await fudao.ExtendAsync(teacher);
        });
    }
    /**
     * 查詢輔導是否可以延長
     *
     * @param {string} fudaoId 輔導Id
     * @returns {boolean}
     *
     * true: 輔導可延長
     *
     * false: 輔導不可延長
     *
     * @memberof FudaoClientApplicationServiceBase
     */
    canExtendFudao(fudaoId) {
        const result = this.executeFudaoOperation(fudaoId, (fudao) => {
            const teacher = this._curFudaoUser;
            return fudao.CanExtendFudao(teacher);
        }, false);
        return result;
    }
    /**
     * 老師邀請視訊通話
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<FudaoSession>} 已經發送開始邀請的FudaoSession，供接下來開始Session與結束Session使用，如果邀請失敗會回傳FudaoSession.INVALID_FUDAO_SESSION
     * @memberof FudaoClientApplicationServiceBase
     */
    async inviteFudaoVideoChatAsync(fudaoId) {
        return await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            const fudaoSession = await fudao.InviteStartSessionAsync(teacher, FudaoDefinition_1.FudaoSessionType.TeacherVideo);
            //SimulateStudentFudaoSessionResponse(FudaoCommand.TeacherInviteStartSession, fudao, fudaoSession, teacher);
            return fudaoSession;
        }, FudaoDefinition_1.FudaoSession.INVALID_FUDAO_SESSION);
    }
    /**
     * 老師邀請音訊通話
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<FudaoSession>} 已經發送開始邀請的FudaoSession，供接下來開始Session與結束Session使用，如果邀請失敗會回傳FudaoSession.INVALID_FUDAO_SESSION
     * @memberof FudaoClientApplicationServiceBase
     */
    async inviteFudaoAudioChatAsync(fudaoId) {
        return await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            const fudaoSession = await fudao.InviteStartSessionAsync(teacher, FudaoDefinition_1.FudaoSessionType.Audio);
            //SimulateStudentFudaoSessionResponse(FudaoCommand.TeacherInviteStartSession, fudao, fudaoSession, teacher);
            return fudaoSession;
        }, FudaoDefinition_1.FudaoSession.INVALID_FUDAO_SESSION);
    }
    /**
     * 老師邀請白板教學
     *
     * @param {string} fudaoId 輔導Id
     * @returns {Promise<FudaoSession>} 已經發送開始邀請的FudaoSession，供接下來開始Session與結束Session使用，如果邀請失敗會回傳FudaoSession.INVALID_FUDAO_SESSION
     * @memberof FudaoClientApplicationServiceBase
     */
    async inviteFudaoWhiteboardAsync(fudaoId) {
        return await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            const fudaoSession = await fudao.InviteStartSessionAsync(teacher, FudaoDefinition_1.FudaoSessionType.Whiteboard);
            //SimulateStudentFudaoSessionResponse(FudaoCommand.TeacherInviteStartSession, fudao, fudaoSession, teacher);
            return fudaoSession;
        }, FudaoDefinition_1.FudaoSession.INVALID_FUDAO_SESSION);
    }
    /**
     * 老師取消開始Session邀請
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經發送開始邀請的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async cancelFudaoStartSessionInvitionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            await fudao.CancelStartSessionInvitionAsync(teacher, fs);
        });
    }
    /**
     * 學生接受老師開始Session邀請
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經接收開始邀請的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async acceptFudaoStartSessionInvitionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const student = this._curFudaoUser;
            await fudao.AcceptStartSessionInvitionAsync(student, fs);
        });
    }
    /**
     * 學生拒絕老師開始Session邀請
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經接收開始邀請的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async rejectFudaoStartSessionInvitionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const student = this._curFudaoUser;
            await fudao.RejectStartSessionInvitionAsync(student, fs);
        });
    }
    /**
     * 學生無回應老師開始Session邀請
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經發送/接收開始邀請的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async noResponseFudaoStartSessionInvitionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            await fudao.NoResponseStartSessionInvitionAsync(this._curFudaoUser, fs);
        });
    }
    /**
     * 老師或學生開始Session
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經發送/接收開始邀請的FudaoSession
     * @param {object|null} videoContainer 顯示Video所需<div>物件
     *  - FudaoSession.SessionType === FudaoSessionType.TeacherVideo, 需放<div>物件來讓底層的Video可以顯示在<div>上
     *  - 其他種類FudaoSession.SessionType則傳入null
     *
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async startFudaoSessionAsync(fudaoId, fs, videoContainer) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            await fudao.StartFudaoSessionAsync(this._curFudaoUser, fs, videoContainer);
        });
    }
    /**
     * 老師邀請結束Session
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經開始的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async inviteEndFudaoSessionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            await fudao.InviteEndSessionAsync(teacher, fs);
            //SimulateStudentFudaoSessionResponse(FudaoCommand.TeacherInviteEndSession, fudao, fs, teacher);
        });
    }
    /**
     * 老師取消結束Session邀請
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經開始的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async cancelFudaoEndSessionInvitionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            await fudao.CancelEndSessionInvitionAsync(teacher, fs);
        });
    }
    /**
     * 學生接受老師結束Session邀請
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經開始的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async acceptFudaoEndSessionInvitionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const student = this._curFudaoUser;
            await fudao.AcceptEndSessionInvitionAsync(student, fs);
        });
    }
    /**
     * 學生拒絕老師結束Session邀請
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經開始的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async rejectFudaoEndSessionInvitionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const student = this._curFudaoUser;
            await fudao.RejectEndSessionInvitionAsync(student, fs);
        });
    }
    /**
     * 學生無回應結束Session邀請
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經開始的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async noResponseFudaoEndSessionInvitionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            await fudao.NoResponseEndSessionInvitionAsync(this._curFudaoUser, fs);
        });
    }
    /**
     * 老師結束Session
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經開始的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async endFudaoSessionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            const teacher = this._curFudaoUser;
            await fudao.EndFudaoSessionAsync(teacher, fs);
        });
    }
    /**
     * 老師或學生離開Session，不需確認，對應到網路斷線等等非使用者控制狀況的清理機制
     *
     * @param {string} fudaoId 輔導Id
     * @param {FudaoSession} fs 之前已經開始的FudaoSession
     * @returns {Promise<void>}
     * @memberof FudaoClientApplicationServiceBase
     */
    async exitFudaoSessionAsync(fudaoId, fs) {
        await this.executeFudaoOperationAsync(fudaoId, async (fudao) => {
            await fudao.ExitFudaoSessionAsync(this._curFudaoUser, fs);
        });
    }
    switchFudaoSessionVideoSource(fudaoId, fs) {
        this.executeFudaoOperation(fudaoId, (fudao) => {
            const teacher = this._curFudaoUser;
            //fudao.SwitchFudaoSessionNextVideoSource(teacher, fs);
        });
    }
    async clearAllLocalDataAsync() {
        await this.executeAsync(async () => {
            await this._fudaoRepo.ClearAsync();
        });
    }
    executeFudaoOperation(fudaoId, operation, defaultReturnValue = {}, memberName = "") {
        try {
            if (!fudaoId)
                throw new FudaoApplicationServiceError("fudaoId should not be empty");
            if (this._curFudaoUser === FudaoUser_1.FudaoUser.INVALID_FUDAO_USER)
                throw new FudaoApplicationServiceError("No related fudao user");
            const fudao = this._fudaoRepo.FudaoOfId(fudaoId);
            if (fudao === Fudao_1.Fudao.INVALID_FUDAO)
                throw new FudaoApplicationServiceError(`Fudao=${fudaoId} not found.`);
            return operation(fudao);
        }
        catch (err) {
            const errorMsg = `${memberName || ""}: ${err.message}`;
            const appServiceError = new FudaoApplicationServiceError(errorMsg, err);
            this.reportError(appServiceError);
            return defaultReturnValue;
        }
    }
    async executeFudaoOperationAsync(fudaoId, operation, defaultReturnValue = {}, memberName = "") {
        try {
            if (!fudaoId)
                throw new FudaoApplicationServiceError("fudaoId should not be empty");
            if (this._curFudaoUser === FudaoUser_1.FudaoUser.INVALID_FUDAO_USER)
                throw new FudaoApplicationServiceError("No related fudao user");
            const fudao = this._fudaoRepo.FudaoOfId(fudaoId);
            if (fudao === Fudao_1.Fudao.INVALID_FUDAO)
                throw new FudaoApplicationServiceError(`Fudao=${fudaoId} not found.`);
            return await operation(fudao);
        }
        catch (err) {
            const errorMsg = `${memberName || ""}: ${err.message}`;
            const appServiceError = new FudaoApplicationServiceError(errorMsg, err);
            this.reportError(appServiceError);
            return defaultReturnValue;
        }
    }
    async executeAsync(operation, defaultReturnValue = {}, memberName = "") {
        try {
            if (this._curFudaoUser === FudaoUser_1.FudaoUser.INVALID_FUDAO_USER)
                throw new FudaoApplicationServiceError("No related fudao user");
            return await operation();
        }
        catch (err) {
            const errorMsg = `${memberName || ""}: ${err.message}`;
            const appServiceError = new FudaoApplicationServiceError(errorMsg, err);
            this.reportError(appServiceError);
            return defaultReturnValue;
        }
    }
    execute(operation, defaultReturnValue = {}, memberName = "") {
        try {
            if (this._curFudaoUser === FudaoUser_1.FudaoUser.INVALID_FUDAO_USER)
                throw new FudaoApplicationServiceError("No related fudao user");
            return operation();
        }
        catch (err) {
            const errorMsg = `${memberName || ""}: ${err.message}`;
            const appServiceError = new FudaoApplicationServiceError(errorMsg, err);
            this.reportError(appServiceError);
            return defaultReturnValue;
        }
    }
    SimulateStudentResponse(cmdName, fudao, teacher) {
        //return;
        switch (cmdName) {
            case FudaoCommand_1.FudaoCommand.TeacherInviteStartFudao:
                const simulateStudentStartInRes = async () => {
                    await TypeScriptUtils_1.delay(2000);
                    //模擬老師收到學生接受開始輔導邀請
                    await this._cmdHub.receiveCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteStartFudaoCommand(fudao.ToFudaoDto(), teacher, RtcCommand_1.CmdType.ResponseAccept));
                    //模擬老師收到學生拒絕開始輔導邀請
                    //await _cmdHub.ReceiveCommandAsync(FudaoCommand.TeacherInviteStudentCommand(FudaoDto.From(fudao), teacher, CmdType.ResponseReject));
                };
                simulateStudentStartInRes();
                break;
            case FudaoCommand_1.FudaoCommand.TeacherInviteEndFudao:
                const simulateStudentEndInRes = async () => {
                    await TypeScriptUtils_1.delay(2000);
                    //模擬老師收到學生接受結束輔導邀請
                    await this._cmdHub.receiveCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteEndFudaoCommand(fudao.ToFudaoDto(), teacher, RtcCommand_1.CmdType.ResponseAccept));
                    //模擬老師收到學生拒絕結束輔導邀請
                    //await _cmdHub.ReceiveCommandAsync(FudaoCommand.InviteStudentCommand(FudaoDto.From(fudao), teacher, CmdType.ResponseReject));
                };
                simulateStudentEndInRes();
                break;
            case FudaoCommand_1.FudaoCommand.TeacherInviteExtendFudao:
                const simulateStudentExtendInRes = async () => {
                    await TypeScriptUtils_1.delay(2000);
                    //模擬老師收到學生接受延長輔導邀請
                    await this._cmdHub.receiveCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteExtendFudaoCommand(fudao.ToFudaoDto(), teacher, RtcCommand_1.CmdType.ResponseAccept));
                    //模擬老師收到學生拒絕延長輔導邀請
                    //await _cmdHub.ReceiveCommandAsync(FudaoCommand.TeacherInviteExtendFudaoCommand(FudaoDto.From(fudao), teacher, CmdType.ResponseReject));
                };
                simulateStudentExtendInRes();
                break;
        }
    }
    SimulateStudentFudaoSessionResponse(cmdName, fudao, fudaoSession, teacher) {
        //return;
        switch (cmdName) {
            case FudaoCommand_1.FudaoCommand.TeacherInviteStartSession:
                const simulateStudentInviteStartSessionRes = async () => {
                    await TypeScriptUtils_1.delay(2000);
                    //模擬老師收到學生接受Session邀請
                    await this._cmdHub.receiveCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteStartSessionCommand(fudao.ToFudaoDto(), fudaoSession, teacher, RtcCommand_1.CmdType.ResponseAccept));
                    //模擬老師收到學生拒絕Session邀請
                    //await _cmdHub.ReceiveCommandAsync(FudaoCommand.TeacherInviteStartSessionCommand(
                    //FudaoDto.From(fudao), fudaoSession, teacher, CmdType.ResponseReject));
                };
                simulateStudentInviteStartSessionRes();
                break;
            case FudaoCommand_1.FudaoCommand.TeacherInviteEndSession:
                const simulateStudentInviteEndSessionRes = async () => {
                    await TypeScriptUtils_1.delay(2000);
                    //模擬老師收到學生接受結束Session邀請
                    await this._cmdHub.receiveCommandAsync(FudaoCommand_1.FudaoCommand.TeacherInviteEndSessionCommand(fudao.ToFudaoDto(), fudaoSession, teacher, RtcCommand_1.CmdType.ResponseAccept));
                    //模擬老師收到學生拒絕結束Session邀請
                    //await _cmdHub.ReceiveCommandAsync(FudaoCommand.TeacherInviteEndSessionCommand(
                    //FudaoDto.From(fudao), fudaoSession, teacher, CmdType.ResponseReject));
                };
                simulateStudentInviteEndSessionRes();
                break;
        }
    }
}
exports.FudaoClientApplicationServiceBase = FudaoClientApplicationServiceBase;
exports.FudaoApplicationServiceErrorName = "FudaoApplicationServiceError";
class FudaoApplicationServiceError extends CommonBaseError_1.CommonBaseError {
}
exports.FudaoApplicationServiceError = FudaoApplicationServiceError;
//# sourceMappingURL=FudaoClientApplicationServiceBase.js.map